import { createSelector } from 'reselect';

import { getBodyData } from '../../selectors';
import {
  DELIVERY_POINTS_SHOW_COUNT,
  DELIVERY_POINT_VIEW_MAP,
  DELIVERY_POINT_VIEW_LIST,
  DELIVERY_POINT_SORT_DATE,
  DELIVERY_POINT_SORT_METRO,
  DELIVERY_POINT_SORT_ADDR,
  DELIVERY_POINT_GTM_VIEW_MAP,
  DELIVERY_POINT_GTM_VIEW_LIST_SORT_METRO,
  DELIVERY_POINT_GTM_VIEW_LIST_SORT_ADDR,
  DELIVERY_POINT_GTM_VIEW_LIST_SORT_DATE,
} from './constants';

export const getDeliveryData = (state) => getBodyData(state).deliveryDetails || {};
export const getDeliverySortState = (state) => getDeliveryData(state).sortWidgetState || {};
export const getDeliverySortActiveButton = (state) =>
  getDeliverySortState(state).activeButton || DELIVERY_POINT_SORT_METRO;
export const getDeliveryCurrentView = (state) =>
  getDeliverySortState(state).currentView || DELIVERY_POINT_VIEW_LIST;

export const getDeliverySortReverseState = (state) => getDeliverySortState(state).reverse || false;
export const getDeliverySortButtons = (state) => getDeliverySortState(state).usingButtons || [];
export const getDeliveryShowPointsCount = (state) =>
  getDeliveryData(state).officesToShow || DELIVERY_POINTS_SHOW_COUNT;

export const getDeliveryTakeawayPoints = createSelector(
  getDeliveryData,
  ({ deliveryPoints }) => deliveryPoints || [],
);

export const getBasketId = createSelector(getDeliveryData, ({ basketId }) => basketId);

export const getOrderInfo = createSelector(getDeliveryData, ({ orderInfo }) => orderInfo);

export const getOrderInfoLoading = createSelector(
  getDeliveryData,
  ({ orderInfoLoading }) => orderInfoLoading,
);

export const getDeliveryOfficesListSortFunc = createSelector(
  getDeliverySortActiveButton,
  getDeliverySortReverseState,
  (sortBy, reverse) => {
    switch (sortBy) {
      case DELIVERY_POINT_SORT_DATE: {
        return null;
      }
      case DELIVERY_POINT_SORT_ADDR: {
        return (a, b) => {
          // we usin 'z' as no data parameter in order to push items without data to end of array
          const addressFromA = (a.address || 'яяяя').toString().toLowerCase();
          const addressFromB = (b.address || 'яяяя').toString().toLowerCase();
          return reverse ?
              -addressFromA.localeCompare(addressFromB)
            : addressFromA.localeCompare(addressFromB);
        };
      }
      case DELIVERY_POINT_SORT_METRO: {
        return (a, b) => {
          const metroFromA = ((a.subway || {}).name || 'яяяя').toString().toLowerCase();
          const metroFromB = ((b.subway || {}).name || 'яяяя').toString().toLowerCase();
          return reverse ?
              -metroFromA.localeCompare(metroFromB)
            : metroFromA.localeCompare(metroFromB);
        };
      }
      default:
        return null;
    }
  },
);

/** selector for GTM purposes */
export const getDeliveryGTMPointType = createSelector(
  getDeliveryCurrentView,
  getDeliverySortActiveButton,
  (view, sortBy) => {
    switch (view) {
      case DELIVERY_POINT_VIEW_MAP: {
        return DELIVERY_POINT_GTM_VIEW_MAP;
      }
      case DELIVERY_POINT_VIEW_LIST: {
        if (sortBy === DELIVERY_POINT_SORT_METRO) {
          return DELIVERY_POINT_GTM_VIEW_LIST_SORT_METRO;
        } else if (sortBy === DELIVERY_POINT_SORT_ADDR) {
          return DELIVERY_POINT_GTM_VIEW_LIST_SORT_ADDR;
        }
        return DELIVERY_POINT_GTM_VIEW_LIST_SORT_DATE;
      }
      default:
        return DELIVERY_POINT_GTM_VIEW_LIST_SORT_METRO;
    }
  },
);
// ===
